export default __webpack_public_path__ + "static/media/default.33168f44937b26ad52d7e4a95cc4522b.png";